import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
    },
}));

export default ({closeModal, title, headerWithX}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar
                    style={{
                        position: 'relative',
                        justifyContent: 'center',
                        minHeight: 52,
                    }}
                >
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label={headerWithX ? 'Close dialog' : 'Go back'}
                        onClick={closeModal}
                        style={{
                            position: 'absolute',
                            left: 4,
                            margin: 0,
                            padding: 8,
                            zIndex: 1,
                        }}
                    >
                        {headerWithX ? <CloseIcon/> : <ArrowBackIosIcon/>}
                    </IconButton>
                    <Typography
                        variant="subtitle1"
                        component="h2"
                        style={{
                            margin: 0,
                            padding: '0 48px',
                            textAlign: 'center',
                            fontWeight: 600,
                            fontSize: '0.95rem',
                            lineHeight: 1.25,
                            letterSpacing: '0.02em',
                        }}
                    >
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>
        </div>
    );
}
